import type { DashboardFinalRoundDto } from "@/modules/boxDashboard/gateway/boxDashboardApiDto"
import { word } from "@/modules/core/utils/i18n"
import type { HUImage } from "@/modules/types/imageTypes"
import dayjs from "dayjs"

export class FinalRoundMemberEntity {
  constructor(
    public readonly id: string,
    public readonly memberId: string,
    public readonly firstname: string | null,
    public readonly lastname: string | null,
    public readonly username: string | null,
    public readonly avatar: HUImage | null,
    public readonly note: string | null,
    public readonly purchaseName: string,
    public readonly remainingCount: number | null,
    public readonly totalCount: number | null,
    public readonly endDate: string | null,
    public readonly sessionsLast30Days: number,
  ) {}

  static fromDto(dto: DashboardFinalRoundDto): FinalRoundMemberEntity {
    return new FinalRoundMemberEntity(
      dto.id,
      dto.boxMember.id,
      dto.boxMember.firstname,
      dto.boxMember.lastname,
      dto.boxMember.username,
      dto.boxMember.avatar ?? null,
      dto.boxMember.note,
      dto.purchaseName,
      dto.remainingCount,
      dto.totalCount,
      dto.endDate,
      dto.sessionsLast30Days,
    )
  }

  getFullName(): string {
    return `${this.firstname ?? ""} ${this.lastname ?? ""}`
  }

  getEndDateFormatted(): string {
    return this.endDate ? dayjs(this.endDate).format("L") : "--"
  }

  getDaysRemaining(): string {
    return this.endDate ? `${dayjs(this.endDate).diff(dayjs(), "day")}` : "∞"
  }

  isClassPass(): boolean {
    return this.remainingCount !== null && this.totalCount !== null
  }

  getBadgeLabel(): string {
    if (this.isClassPass() && this.remainingCount !== null && this.totalCount !== null) {
      return `${this.remainingCount}/${this.totalCount}`
    }
    return `${this.getDaysRemaining()}${word("global.day.label", { count: 1 })[0]}`
  }
}
